import countdown from './countdown.js'

const _MIXINS_ = {
	countdown: countdown
}

export default _MIXINS_
